import { useTranslation } from 'react-i18next';
import styles from '../SearchResultPanel.module.scss';

export const SearchResultsEmptyState = () => {
  const { t } = useTranslation('header');
  return (
    <div
      className={styles.SearchResults}
      data-automation-id="MainSearchNoResultsFound"
    >
      {t('SearchNoResultsFound')}
    </div>
  );
};
